<div id="language-selection-pop">
    <div (click)="closeLanguagePicker()" id="close-btn">
        <span class="icon icon_close"></span>
    </div>
    <div class="pg-inner-pop">
        <div class="pg-title">
            <h2>{{ 'CP_LM_LANDINGPAGE_SELECTLANG' | translate }}</h2>
        </div>

        <div class="language-selection">
            <div class="langage-list global">
                <h5>
                    <span>{{ 'CP_LM_LANDINGPAGE_ALLANG' | translate }}</span>
                </h5>
                <ul class="language">
                    @for (language of allLanguages; track language) {
                        <li class="clm-3 clm-tab-8">
                            <a
                                ><span
                                    class="enable-selection"
                                    id="locale-desc"
                                    (click)="switchLanguage(language.localeCode)"
                                >
                                    {{ language.localeDescription }}
                                </span></a
                            >
                        </li>
                    }
                </ul>
            </div>
        </div>
    </div>
</div>
